import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, List, Typography } from '@mui/material';

// project imports
import NavItem from '../NavItem';
import NavCollapse from '../NavCollapse';
import React from 'react';

// ==============================|| SIDEBAR MENU LIST GROUP ||============================== //

function NavGroup({ item }) {
    const theme = useTheme();
    // menu list collapse & items
    const items = item.children?.map((menu, index) => {
        switch (menu.type) {
            case 'collapse':
                return <NavCollapse key={index} menu={menu} level={1} />;
            case 'item':
                return <NavItem key={index} item={menu} level={1} />;
            case 'divider':
                return <Box key={index} />;
            //return <Divider sx={{ mt: 0.25, mb: 1.25, mr: '40%' }} color={'#00000'} />;
            default:
                return (
                    <Typography key={index} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    return (
        <>
            <List
                subheader={
                    item.title && (
                        <Typography
                            variant="caption"
                            sx={{ ...theme.typography.menuCaption }}
                            display="block"
                            gutterBottom
                        >
                            {item.title}
                            {item.caption && (
                                <Typography
                                    variant="caption"
                                    sx={{ ...theme.typography.subMenuCaption }}
                                    display="block"
                                    gutterBottom
                                >
                                    {item.caption}
                                </Typography>
                            )}
                        </Typography>
                    )
                }
            >
                {items}
            </List>

            {/* group divider */}
            {/*<Divider sx={{ mt: 0.25, mb: 1.25 }} />*/}
        </>
    );
}

NavGroup.propTypes = {
    item: PropTypes.object
};

export default NavGroup;
